import { action, Config, _ } from "utils";
import PavilionStore from "./fairstore";
import SuperfairStore from "./superfairstore";
import JobStore from "./jobstore";
import StandStore from "./standstore";
import EventStore from "./eventstore";
import SelectedPavilionStore from "./SelectedPavilionStore";
import AuthStore from "./authstore";
import ChatStore from "./chatstore";
import ApplyStore from "./applystore";

const FairStore = PavilionStore;

export function add(value = 1) {
  action("CHANGE-IN-PROGRESS");

  setTimeout(() => {
    action("ADD", { value });
  }, 3000);
}

export function showOverlay(name) {
  $(".main").addClass("blur");
  $("body").trigger("vv.overlay.show", name);
}

export function hideOverlay(name = false) {
  $(".main").removeClass("blur");
  $("body").trigger("vv.overlay.hide", name);
}

export function addOverlayListener(component) {
  $("body").on("vv.overlay.show", component.onShow);
  $("body").on("vv.overlay.hide", component.onHide);
}

export function removeOverlayListener(component) {
  $("body").off("vv.overlay.show", component.onShow);
  $("body").off("vv.overlay.hide", component.onHide);
}

function extend(val = {}) {
  return Object.assign(
    {
      domain: Config.domain,
    },
    val
  );
}

export function loadJobs(query = "", standId = "") {
  action("JOBS-LOADING", { standId });

  var params = {
    "stand.fair.id": PavilionStore.getFairId(),
    "stand.id": standId,
    "stand.active": 1,
    query: query,
  };

  $.get(
    Config.api.jobs,
    params,
    function(data) {
      action("JOBS-CHANGED", { jobs: data });
      filterJobs();
    },
    "json"
  );
}

export function setJobFilters(filters) {
  action("JOB-FILTERS-SET", filters);
}

export function loadDetails(jobId) {
  action("JOB-DETAILS-CHANGED", { details: null });

  var url = Config.api.details.replace("{jobId}", jobId);
  $.get(url, (data) => {
    action("JOB-DETAILS-CHANGED", { details: data });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      job_id: details.id,
      job_pagetype: "offerdetail",
      job_locid: "HR",
      job_title_name_job_details: details.title,
      job_category_name_job_details: details.offerCategory
        ? details.offerCategory.name
        : "",
    });
  });
}

export function loadEventDetails(eventId) {
  action("EVENT-DETAILS-CHANGED", { details: null });

  var url = Config.api.eventDetails.replace("{eventId}", eventId);
  $.get(url, (data) => {
    action("EVENT-DETAILS-CHANGED", { details: data });
  });
}

export function login() {
  action("LOGIN-STATUS-CHANGED", { loading: true, auth: null });

  //TODO: replace with productions values
  var params = {
    email: "chat@test.com",
    password: "chat@test.com",
  };

  $.post(Config.api.login, params, (data) => {
    action("LOGIN-STATUS-CHANGED", { loading: false, auth: data });
  });
}

export function chatRoomChanged(pavilion, stand) {
  action("CHAT-ROOM-CHANGED", { stand });

  if (AuthStore.isAuthorized() && stand != null) {
    getChatInfo(stand);
    loadMessages(stand);
  }

  loadPavilion(pavilion);
}

export function reloadMessages() {
  console.log("reloading messages");

  var slug = ChatStore.getStandSlug();
  if (AuthStore.isAuthorized() && slug != null) {
    loadMessages(slug);
  }
}

export function sendMessage(stand, content) {
  var params = {
    stand: StandStore.findStandId(stand),
    content: content,
  };

  var token = AuthStore.getToken();

  $.ajax({
    url: Config.api.send,
    method: "POST",
    data: params,
    headers: {
      Authorization: "Bearer " + token,
    },
    dataType: "json",
  })
    .done((data) => {
      var currentMessages = ChatStore.getMessages();
      action("MESSAGES-CHANGED", {
        messages: currentMessages.concat([data]),
        stand: stand,
      });
    })
    .fail((data) => {
      if (data.status == "401") {
        action("LOGIN-STATUS-CHANGED", {
          loading: false,
          auth: null,
          msg: null,
        });
      }
    });
}

export function loadMessages(stand) {
  var lastMessageId = ChatStore.getLastMessageId();
  var id = StandStore.findStandId(stand);
  var now = Date.now();
  var params = {
    stand: id,
    last_message_id: lastMessageId,
    ctime: now,
  };
  var token = AuthStore.getToken();

  $.ajax({
    url: Config.api.chat,
    data: params,
    headers: {
      Authorization: "Bearer " + token,
    },
    dataType: "json",
  })
    .done((data) => {
      var currentMessages = ChatStore.getMessages();
      action("MESSAGES-CHANGED", {
        messages: currentMessages.concat(data),
        stand: stand,
      });
    })
    .fail((data) => {
      if (data.status == "401") {
        action("LOGIN-STATUS-CHANGED", {
          loading: false,
          auth: null,
          msg: null,
        });
      }
    });
}

export function clearChatHash() {
  action("CHAT-HASH-CHANGED", { hash: null });
}

export function getChatInfo(stand) {
  var id = StandStore.findStandId(stand);
  var now = Date.now();
  var params = {
    stand: id,
    ctime: now,
  };
  var token = AuthStore.getToken();

  action("CHAT-HASH-CHANGED", { hash: null });
  $.ajax({
    url: Config.api.chatInfo,
    data: params,
    headers: {
      Authorization: "Bearer " + token,
    },
    dataType: "json",
  })
    .done((data) => {
      action("CHAT-HASH-CHANGED", { hash: data.hash });
    })
    .fail((data) => {
      action("CHAT-HASH-CHANGED", { hash: null });
      if (data.status == "401") {
        action("LOGIN-STATUS-CHANGED", {
          loading: false,
          auth: null,
          msg: null,
        });
      }
    });
}

export function toggleChatNotificationSetting(value) {
  action("CHAT-NOTIFICATION-CHANGED", { chatNotificationsEnabled: null });
  let token = AuthStore.getToken();
  $.ajax({
    url: Config.api.chatNotification,
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
    },
    dataType: "json",
  })
    .done((data) => {
      action("CHAT-NOTIFICATION-CHANGED", data);
    })
    .fail((data) => {
      action("ERROR");
    });
}

export function getChatNotificationSetting() {
  let token = AuthStore.getToken();
  $.ajax({
    url: Config.api.chatNotification,
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
    },
    dataType: "json",
  })
    .done((data) => {
      action("CHAT-NOTIFICATION-CHANGED", data);
    })
    .fail((data) => {
      action("ERROR");
    });
}

export function loadStands() {
  if (StandStore.isReady() == false) {
    action("STANDS-LOADING");

    var params = {
      "fair.id": PavilionStore.getFairId(),
      active: 1,
    };

    return $.get(
      Config.api.stands,
      params,
      function(stands) {
        action("STANDS-CHANGED", { stands });
      },
      "json"
    ).fail(function() {
      action("ERROR");
    });
  }
}

export function loadEvents() {
  if (EventStore.isReady() == false) {
    action("EVENTS-LOADING");

    var params = {
      "fair.id": PavilionStore.getFairId(),
      active: 1,
    };

    return $.get(
      Config.api.events,
      params,
      function(events) {
        action("EVENTS-CHANGED", { events });
      },
      "json"
    ).fail(function() {
      action("ERROR");
    });
  }
}

export function loadPavilions() {
  var params = extend();

  return $.get(
    Config.api.pavilions,
    params,
    function(pavilions) {
      action("PAVILIONS-CHANGED", pavilions);
    },
    "json"
  ).fail(function() {
    action("ERROR");
  });
}

export function pavilionsChanged(data) {
  let frontFairLogo = Config.resourceBaseUrl + "rsp_logo_" + data.id + ".png";
  action("PAVILIONS-CHANGED", { ...data, ...{ frontFairLogo } });
}

export function fairsChanged(data) {
  action("FAIRS-CHANGED", data);
}

export function setFairLogoUrl(logo) {
  action("FAIR-LOGO-URL-CHANGED", { logoUrl: logo });
}

export function resetFrontFairLogoUrl() {
  action("RESET-FRONT-FAIR-LOGO-URL", {
    url: Config.resourceBaseUrl + "rsp_logo.png",
  });
}

function queryJobs() {
  var query = JobStore.getQuery();
  var filters = JobStore.getFilters();

  new Promise((resolve, reject) => {
    resolve(JobStore.filter(query, filters));
  }).then((activeJobs) => {
    action("ACTIVE-JOBS-CHANGED", { activeJobs });
  });
}

export function filterJobs() {
  action("JOBS-FILTER");
  setTimeout(queryJobs, 50);
}

export function jobFastApplyClicked(id) {
  action("JOB-FAST-APPLY-CLICKED", { id });
}

export function toggleMenu(visible) {
  action("MENU-VISIBILITY-CHANGED", { visible });
}

var queryTimer = null;

export function searchQueryChanged(query) {
  action("SEARCH-QUERY-CHANGED", { query: query });

  clearTimeout(queryTimer);
  queryTimer = setTimeout(queryJobs, 500);
}

export function standSearchQueryChanged(query) {
  action("STAND-SEARCH-QUERY-CHANGED", { query: query });

  clearTimeout(queryTimer);
  queryTimer = setTimeout(queryChanged, 500);
}

import { pavilions } from "./data";

export function loadWhy(pavilion, stand) {
  action("WHY-CHANGED", { pavilion, stand });
  loadPavilion(pavilion);

  var id = SelectedPavilionStore.getStandId(stand);

  if (id != null) {
    loadWhyUs(id);
  }
}

export function loadWhyUs(standId) {
  var api = Config.api.why;
  var url = api.replace("{stand.id}", standId);
  console.log(url);

  $.get(
    url,
    (data) => {
      action("WHY-DATA-CHANGED", data);
    },
    "json"
  );
}

export function loadPavilion(slug) {
  var pavilion = SelectedPavilionStore.getSelectedPavilionSlug();

  if (slug != null && (pavilion == null || pavilion != slug)) {
    hideOverlay();
    action("LOADING-SELECTED-PAVILION");

    var id = FairStore.getPavilionId(slug);

    $.get(
      Config.api.pavilionjson + id + "?domain=" + window.location.host,
      function(data) {
        if (data.jsonData) {
          action("SELECTED-PAVILION-CHANGED", data.jsonData);
        } else {
          console.error("No pavilion json", id);
        }
      },
      "json"
    );
  }
}

export function facebook(token) {
  let domain = FairStore.getFairDomain();

  var params = {
    token,
    domain,
  };

  action("LOGIN-STATUS-CHANGED", { loading: true, auth: null, msg: null });

  $.get(Config.api.auth.facebook, params, "json")
    .done((data) => {
      action("LOGIN-STATUS-CHANGED", { loading: false, auth: data, msg: null });
      getChatNotificationSetting();
    })
    .fail(() => {
      action("LOGIN-STATUS-CHANGED", {
        loading: false,
        auth: null,
        msg: _("Sign in failed"),
      });
    });
}

export function google(token) {
  let domain = FairStore.getFairDomain();

  var params = {
    token,
    domain,
  };

  action("LOGIN-STATUS-CHANGED", { loading: true, auth: null, msg: null });

  $.get(Config.api.auth.google, params, "json")
    .done((data) => {
      action("LOGIN-STATUS-CHANGED", { loading: false, auth: data, msg: null });
      getChatNotificationSetting();
    })
    .fail(() => {
      action("LOGIN-STATUS-CHANGED", {
        loading: false,
        auth: null,
        msg: _("Sign in failed"),
      });
    });
}

export function loadIndex() {
  $.get(
    Config.api.index,
    function(pavilions) {
      action("INDEX-CHANGED", pavilions);
    },
    "json"
  ).fail(function() {
    action("ERROR");
  });
}

export function selectedStandChanged(slug) {
  var selectedSlug = SelectedPavilionStore.getSelectedStandSlug();

  $(window).trigger("vv.repositionStandLinks", slug);

  if (selectedSlug != slug) {
    action("SELECTED-STAND-CHANGED", { slug });

    var standID = StandStore.findStandId(slug);

    if (standID) {
      var params = {
        stand: standID,
      };

      $.ajax({
        url: Config.api.standStats,
        method: "POST",
        data: params,
        dataType: "json",
      });
    }

  }
}

export function ratioChanged(ratio) {
  action("RATIO-CHANGED", { ratio });
}

export function navTo(id) {
  var positionLeft = $(".stands #" + id).position().left;
  $(".scroll-view").animate(
    {
      scrollLeft: positionLeft,
    },
    "fast"
  );
}

export function positionStand(id) {
  setTimeout(function() {
    var stand = id;
    action("SELECTED-STAND-CHANGED", stand);
    navTo(stand);
  });
}

export function loadGallery(pavilion, stand) {
  action("GALLERY-CHANGED", { pavilion, stand });
  loadPavilion(pavilion);
  var id = SelectedPavilionStore.getStandId(stand);
  if (id != null) {
    loadGalleryId(id);
  }
}

export function loadGalleryId(standId) {
  var api = Config.api.gallery;
  var url = api.replace("{stand.id}", standId);
  $.get(
    url,
    (data) => {
      action("GALLERY-DATA-CHANGED", data);
    },
    "json"
  );
}

export function setPlayer(player) {
  action("SET-PLAYER", player);
}

export function gallerySwiped() {
  action("GALLERY-SWIPED");
}

export function loadAbout(pavilion, stand) {
  action("ABOUT-CHANGED");
  const standID = SelectedPavilionStore.getStandId(stand);
  if (standID) {
    const api = Config.api.about;
    const url = api.replace("{stand.id}", standID);
    $.get(
      url,
      (data) => {
        action("ABOUT-DATA-CHANGED", data);
      },
      "json"
    );
  }
}

export function setInfoVisible(visible) {
  action("INFO-STATUS-CHANGED", { visible });
}

export function setOverlayVisible(name, visible) {
  action("OVERLAY-CHANGED", { name, visible });
  $(window).trigger("vv.overlay", { name, visible });
}

export function scrollChanged(offset) {
  action("SCROLL-CHANGED", { offset });
}

export function queryChanged() {
  const query = StandStore.getQuery();
  const filters = StandStore.getFilters();

  new Promise((resolve, reject) => {
    resolve(StandStore.filter(query, filters));
  }).then((activeStands) => {
    action("ACTIVE-STANDS-CHANGED", { activeStands });
  });
}

export function giveawaySelected(giveaway = null) {
  action("GIVEAWAY-SELECTED", { giveaway });
}

export function prizeChanged(args = null) {
  action("PRIZE-CHANGED", { prize: args.giveaway, standId: args.standId });
  $(window).trigger("vv.overlay", { name: "nagrada", visible: true });
}

export function applyForGiveaway(application) {
  action("GIVEAWAY-STATUS-CHANGED", {
    loading: true,
    thankYou: false,
    error: false,
  });

  var token = AuthStore.getToken();

  $.ajax({
    url: Config.api.applyForGiveaway,
    method: "POST",
    data: application,
    headers: {
      Authorization: "Bearer " + token,
    },
    dataType: "json",
  })
    .done(() => {
      action("GIVEAWAY-STATUS-CHANGED", {
        loading: false,
        thankYou: true,
        error: false,
      });
    })
    .always(() => {
      action("GIVEAWAY-STATUS-CHANGED", { loading: false });
    })
    .fail((data) => {
      action("GIVEAWAY-STATUS-CHANGED", {
        loading: false,
        thankYou: false,
        error: true,
      });

      if (data.status == "401") {
        action("LOGIN-STATUS-CHANGED", {
          loading: false,
          auth: null,
          msg: null,
        });
      }
    });
}

export function trackActiveInfo() {
  var activeServiceUrl = Config.api.active.replace(
    "{Fair.id}",
    FairStore.getFairId()
  );

  function activeReader() {
    $.get(activeServiceUrl, (data) => {
      action("ACTIVE-INFO-CHANGED", { info: data });
    });
  }

  activeReader();

  setInterval(activeReader, Config.active.interval);
}

export function showFilterModal(name) {
  $(document).trigger("show-filters-" + name);
}

export function hideFilterModal(name) {
  $(document).trigger("hide-filters-" + name);
}

export function checkStandActivities(args) {
  action("STAND-ACTIVITIES-CHANGED", args);
}

export function checkStandLocations(args) {
  action("STAND-LOCATIONS-CHANGED", args);
}

export function saveFilters(filters) {
  action("FILTERS-SAVED", filters);
}

export function removeFilter(data) {
  action("FILTER-REMOVED", data);
}

export function applyStandActivityFilter(data) {
  action("ACTIVITY-FILTERS-APPLIED", data);
}

export function applyStandLocationFilter(data) {
  action("LOCATION-FILTERS-APPLIED", data);
}

export function jobsApplyFilters() {
  let filters = Object.assign({}, JobStore.getFilters());
  let filterKeys = Object.keys(filters);

  filterKeys.forEach((filterKey) => {
    let flt = filters[filterKey].map((item, i) => {
      item.active = item.selected;
      return item;
    });
    action("JOBS-FILTERS-CHANGED", { filterName: filterKey, filters: flt });
  });
  setTimeout(queryJobs, 500);
}

export function jobsFilterItemClicked(
  filterName,
  clickedItemName,
  clickedItemIndex
) {
  console.log("FILTER CLICK", filterName, clickedItemName);
  let filters = [...JobStore.getFilters()[filterName]];
  filters.find((obj) => {
    if (obj.name === clickedItemName) {
      obj.selected = !obj.selected;
      obj.active = !obj.active;
      return true;
    }
  });
  action("JOBS-FILTERS-CHANGED", { filterName: filterName, filters: filters });
  // jobsApplyFilters();
  setTimeout(queryJobs, 500);
}

export function jobsFilterItemRemoveClicked(
  filterName,
  clickedItemName,
  clickedItemIndex
) {
  let filters = [...JobStore.getFilters()[filterName]];
  let index = filters.findIndex((obj) => {
    if (obj.name === clickedItemName) {
      return true;
    }
  });

  filters[index].active = false;
  filters[index].selected = false;
  action("JOBS-FILTERS-CHANGED", { filterName: filterName, filters: filters });
  setTimeout(queryJobs, 500);
}

export function standsApplyFilters() {
  let filters = Object.assign({}, StandStore.getFilters());
  let filterKeys = Object.keys(filters);

  filterKeys.forEach((filterKey) => {
    let flt = filters[filterKey].map((item, i) => {
      item.active = item.selected;
      return item;
    });
    action("STANDS-FILTERS-CHANGED", { filterName: filterKey, filters: flt });
  });
  setTimeout(queryChanged, 500);
}

export function standsFilterItemClicked(
  filterName,
  clickedItemName,
  clickedItemIndex
) {
  let filters = [...StandStore.getFilters()[filterName]];
  filters.find((obj) => {
    if (obj.name === clickedItemName) {
      obj.selected = !obj.selected;
      return true;
    }
  });
  action("STANDS-FILTERS-CHANGED", {
    filterName: filterName,
    filters: filters,
  });
}

export function standsFilterItemRemoveClicked(
  filterName,
  clickedItemName,
  clickedItemIndex
) {
  let filters = [...StandStore.getFilters()[filterName]];
  let index = filters.findIndex((obj) => {
    if (obj.name === clickedItemName) {
      return true;
    }
  });

  filters[index].active = false;
  filters[index].selected = false;
  action("STANDS-FILTERS-CHANGED", {
    filterName: filterName,
    filters: filters,
  });
  setTimeout(queryChanged, 500);
}

export function openFilterModal(name) {
  let eventName = "filter-show-" + name;
  console.log("trigger event", eventName);
  $(document).trigger(eventName);
}

export function closeFilterModal(name) {
  let eventName = "" + name;
  console.log("trigger event", eventName);
  $(document).trigger(eventName);
}

export function changeFastApply(name, value) {
  action("FAST-APPLY-FIELD-CHANGED", { name, value });
}

export function uploadFastApply(name, value) {
  var reader = new FileReader();
  // reader.readAsText(value, "UTF-8");
  reader.readAsBinaryString(value);
  reader.onload = (evt) => {
    var d = {
      name: "file",
      value: {
        name: value.name,
        content: evt.target.result,
      },
    };
    action("FAST-APPLY-DOCUMENT-UPLOADED", d);
  };
}

export function fastApplyAnonSubmit() {
  action("FAST-APPLY-LOADING-CHANGED", { loading: true });
  var anonApplyData = ApplyStore.getApplicationAnonData();
  let url = Config.api.jobsApplyAnon;
  $.post({ url, data: anonApplyData, dataType: "json" })
    .done((data) => {
      if (data.error) {
        action("FAST-APPLIED-ERROR", data.error);
      } else {
        fastApplyGA(anonApplyData.jobIds.join(), data.data.success.length);
        action("FAST-APPLIED-SUCCESS", data.data);
      }
    })
    .fail((error) => {
      action("FAST-APPLIED-ERROR", error.responseJSON);
    })
    .always(() => {
      action("FAST-APPLY-LOADING-CHANGED", { loading: false });
    });
}

export function fastApplySubmit() {
  action("FAST-APPLY-LOADING-CHANGED", { loading: true });
  var applyData = ApplyStore.getApplicationData();
  let url = Config.api.jobsApply;
  $.post({ url, data: applyData, dataType: "json" })
    .done((data) => {
      if (data.error) {
        action("FAST-APPLIED-ERROR", data.error);
      } else {
        fastApplyGA(applyData.jobIds.join(), data.data.success.length);
        action("FAST-APPLIED-SUCCESS", data.data);
      }
    })
    .fail((error) => {
      action("FAST-APPLIED-ERROR", error.responseJSON);
    })
    .always(() => {
      action("FAST-APPLY-LOADING-CHANGED", { loading: false });
    });
}

function fastApplyGA(idsString, successNumber) {
  let event = {
    hitType: "event",
    eventCategory: "search",
    eventAction: "fastApply",
    eventLabel: idsString,
    eventValue: successNumber,
  };
  console.log("ga", event);
  ga("send", event);

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "group_apply",
  });
}

export function clearFastApplyData() {
  action("FAST-APPLY-DATA-CLEARED");
}



// WEBPACK FOOTER //
// ./src/modules/model/Creators.js